import { useCallback } from 'react';
import { countLoginApi } from '@/api/authApi';
import { Car, CustomerInfoApiParams } from '@/types/api/customerApi';

export const useLoginCount = (
  mCustomerId: CustomerInfoApiParams['m_customer_id'],
) => {
  const callCountLoginApi = useCallback(
    async (car: Car, customerId = mCustomerId) => {
      try {
        const { data } = await countLoginApi({
          m_customer_id: customerId,
          t_stock_car_id: car.t_stock_car_id,
        });
        if (!data.success) {
          throw new Error(
            data?.error?.message || 'ログインカウントに失敗しました',
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    [mCustomerId],
  );

  return {
    callCountLoginApi,
  };
};
